import { Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import colors from 'helpers/colors'
import { useState } from 'react'

type Props = {
  title: string
}

export const FixedTitleHeader: React.FC<Props> = ({ title }) => {
  const { xs } = useBreakpoint()
  const [isRendered, setIsRendered] = useState(false)

  return (
    <div
      style={{
        height: xs ? '53px' : '65px',
        padding: xs ? '16px' : '16px 64px',
        position: 'sticky',
        top: xs ? '56px' : '80px',
        left: 0,
        width: '100%',
        background: 'white',
        zIndex: 1,
        borderBottom: `1px solid ${colors.border}`,
      }}
    >
      <Typography.Text
        style={{
          fontSize: xs ? '14px' : '22px',
          lineHeight: 1.5,
          transition:
            'transform .24s ease-in,opacity .24s ease-in,visibility .24s ease-in',
          opacity: isRendered ? 1 : 0,
          visibility: isRendered ? 'visible' : 'hidden',
          transform: isRendered ? 'translateY(0)' : 'translateY(-50%)',
        }}
        ellipsis
        // transitionを有効にするためにsetTimeoutを使用している
        ref={() => setTimeout(() => setIsRendered(true), 100)}
      >
        {title}
      </Typography.Text>
    </div>
  )
}
